import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationService, NotificationDto } from '../../services/notification.service';
import { AlertService } from '../../services/alert.service';
import { DrawerService } from '../drawer/drawer.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-notifications-drawer',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class NotificationsDrawerComponent implements OnInit, OnDestroy {
    notifications: NotificationDto[] = [];
    unreadCount = 0;
    isLoading = false;
    isLastPage = false;
    pageIndex = 1;
    pageSize = 20;
    private subscriptions: Subscription[] = [];

    constructor(
        public notificationService: NotificationService,
        private alertService: AlertService,
        private drawerService: DrawerService,
        private router: Router
    ) { }

    ngOnInit(): void {
        console.log('🔔 NotificationsDrawerComponent initialized');

        // Subscribe to notifications from service
        this.subscriptions.push(
            this.notificationService.notifications$.subscribe(items => {
                console.log('🔔 Notifications updated in drawer:', items.length);
                this.notifications = items;
            })
        );

        this.subscriptions.push(
            this.notificationService.unreadCount$.subscribe(count => {
                this.unreadCount = count;
            })
        );

        // Initial load
        this.loadNotifications(true);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    loadNotifications(isInitial: boolean = false) {
        if (this.isLoading || (this.isLastPage && !isInitial)) return;

        this.isLoading = true;
        if (isInitial) {
            this.pageIndex = 1;
            this.isLastPage = false;
        } else {
            this.pageIndex++;
        }

        console.log(`🔔 Loading notifications page ${this.pageIndex}`);
        this.notificationService.getNotifications(this.pageIndex, this.pageSize).subscribe({
            next: (res) => {
                this.isLoading = false;
                const items = res.Notifications || res.notifications || [];
                if (items.length < this.pageSize) {
                    this.isLastPage = true;
                }
            },
            error: (err) => {
                console.error('🔔 Error loading notifications:', err);
                this.isLoading = false;
            }
        });
    }

    markAsRead(item: NotificationDto, navigate: boolean = false) {
        if (!item.isRead) {
            this.notificationService.markAsRead(item.id).subscribe(() => {
                item.isRead = true;
                if (navigate) {
                    this.navigateToDetail(item);
                }
            });
        } else if (navigate) {
            this.navigateToDetail(item);
        }
    }

    viewDetail(item: NotificationDto, event: Event) {
        event.stopPropagation();
        this.markAsRead(item, true);
    }

    navigateToDetail(notification: NotificationDto): void {
        // Navigate nếu là Invoice/Order
        if (notification.entityType === "OrderCustomer" && notification.entityId) {
            this.router.navigate(["/invoice"], {
                queryParams: { invoiceId: notification.entityId },
            });
        }
        // Parse metadata để lấy URL (fallback)
        else if (notification.metaData) {
            try {
                const metadata = JSON.parse(notification.metaData);
                if (metadata.url) {
                    this.router.navigate([metadata.url]);
                }
            } catch (e) {
                console.error("Invalid metadata JSON:", e);
            }
        }

        // Đóng drawer sau khi click
        this.closeDrawer();
    }

    markAllAsRead() {
        this.notificationService.markAsRead().subscribe();
    }

    deleteNotification(item: NotificationDto, event: Event) {
        event.stopPropagation();
        this.alertService.confirm("Bạn có chắc muốn xóa thông báo này?", "Xóa thông báo").subscribe(ok => {
            if (ok) {
                this.notificationService.deleteNotification(item.id).subscribe(() => {
                    this.alertService.success("Xóa thông báo thành công");
                    this.loadNotifications(true);
                });
            }
        });
    }

    deleteAll() {
        if (this.notifications.length === 0) return;
        this.alertService.confirm(`Bạn có chắc muốn xóa ${this.notifications.length} thông báo đã tải?`, "Xóa thông báo đã tải").subscribe(ok => {
            if (ok) {
                const ids = this.notifications.map(n => n.id);
                this.notificationService.deleteBulk(ids).subscribe(() => {
                    this.alertService.success("Xóa các thông báo thành công");
                    this.loadNotifications(true);
                });
            }
        });
    }

    closeDrawer() {
        this.drawerService.close();
    }
}
